import React, { useEffect, useState } from 'react'
import AnniHeroFlowers from '../Components/widgets/AnniHeroFlowers'
import flowerSpace from './../assets/flower-snip.png'
import backMemories from './../assets/back-banner-item2025.jpg'
import { useParams } from 'react-router-dom';
import axios from 'axios';
import * as CONSTANTS from "../CONSTANTS";
import TopNavigation from '../Components/navigation/TopNavigation';
import { Parser } from "html-to-react";
import SingleMessagesView from '../Components/widgets/SingleMessagesView';
import SingleEventThreeLess from '../Components/widgets/SingleEventThreeLess';
import transition from '../transition';
import MainFooter from '../Components/footer/MainFooter';
import OnviteIntroduction from '../Components/widgets/OnviteIntroduction';
import { Helmet } from 'react-helmet';
import SocialsShare from '../Components/widgets/SocialsShare';

function SingleEvent() {

    const params                                                       = useParams();

    const htmlParser                                                   = new Parser();

    const [currentEvent, setCurrentEvent]                              = useState(null);
    const [onviteEvent, setOnviteEvent]                                = useState(null);

    const [openSectionVows, setOpenSectionVows]                        = useState(null);
    const [rsvpList, setRsvpList]                                      = useState([]);
    const [memEvents, setMemEvents]                                    = useState([]);//ids
    const [memoryList, setMemoryList]                                  = useState([]);
    const [eventTitle, setEventTitle]                                  = useState("LoveDripp - Couple");

    useEffect(() => {     
      collectCurrentEvent();
    }, []);
     
    useEffect(() => {     
      collectCurrentMemoryDripps();
    }, [memEvents]);

    useEffect(() => {
        if(onviteEvent){
            handleCollectRSVPList();
        }
    },[onviteEvent])

    const handleCollectRSVPList = async () => {
        try{

            const res = await axios.get(CONSTANTS.API_URL +"annivites/rsvp/yes/current/index/" + onviteEvent._id);
  
            setRsvpList(res.data);
        }catch(err){
            console.log(err);
        }
    }

    const collectCurrentEvent = async () => {

      try{
  
        const res = await axios.get(CONSTANTS.API_URL +"annivites/current/index/" + params.id);
        
        const weddingDateParts = res.data.weddingDate.split('-'); // ["19", "09", "2021"]
        const weddingDate = new Date(`${weddingDateParts[0]}-${weddingDateParts[1]}-${weddingDateParts[2]}`); // "2021-09-19"

        const today = new Date();
        // Set today's time to 00:00:00 to avoid time issues
        today.setHours(0, 0, 0, 0);

        // Now compare
        if (weddingDate < today) {
            /******
             console.log("***********************");
             console.log("Wedding date is today or in the past");
             console.log(res.data.memoryEvents);
             console.log("#***********************#");
            ***/
            setCurrentEvent(res.data);
            //array Ids
            setMemEvents(res.data.memoryEvents);
        } else {
            setOnviteEvent(res.data);            
        }        
        setEventTitle("Lovedripp  " + res.data.spouseA + " & " + res.data.spouseB)
      }catch (err) {
          console.log(err);        
      }   
    }
    
    const collectCurrentMemoryDripps = async () => {
        
        try{
           
            const idList = {
                "memoryIds" : memEvents
            }
            
            const resObject = await axios.put(CONSTANTS.API_URL +"annivites/list/memory-drips/v1", idList);

            setMemoryList(resObject.data);
        }catch(err){
            console.log(err);
        }
    }

    const toggleSection = (section) => {
        setOpenSectionVows((prev) => (prev === section ? null : section));
    };

  return (
     <div className="main-layer">
        <Helmet>
                    <title>{eventTitle}</title>
        </Helmet>
        <TopNavigation title={"Annisite"} classBack="full-white"/>        
        {
            currentEvent && (
                <div className="content-layer">
                    <AnniHeroFlowers currentEvent={currentEvent} />
                    <div className="section-item">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="vows-main-side">
                                        <h2 className="text-center">Vows</h2>
                                        {
                                            currentEvent && (
                                                <div className="space-y-4">
                                                    {/* Spouse A Section */}
                                                    <div className="accord-item-area">
                                                        <button
                                                            onClick={() => toggleSection("A")}
                                                            className="accord-item-title"
                                                        >
                                                        {currentEvent.spouseA}'s Vows
                                                        </button>
                                                        {openSectionVows === "A" && (
                                                        <div className="accord-body-lay">
                                                            {htmlParser.parse(currentEvent.weddingVowsA)}
                                                        </div>
                                                        )}
                                                    </div>

                                                    {/* Spouse B Section */}
                                                        <div className="accord-item-area">
                                                            <button
                                                            onClick={() => toggleSection("B")}
                                                            className="accord-item-title"
                                                            >
                                                            {currentEvent.spouseB}'s Vows
                                                            </button>
                                                            {openSectionVows === "B" && (
                                                            <div className="accord-body-lay">
                                                                {htmlParser.parse(currentEvent.weddingVowsB)}
                                                            </div>
                                                            )}
                                                        </div>
                                                    </div>
                                            )
                                        }

                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="content-wedding">
                                        <h2 className="text-center">Anniversary</h2>
                                    </div>
                                    <div className="space-image1">
                                        <img src={flowerSpace} className="fl-image" />
                                    </div>
                                    <div className="page-onvite wd-edits">
                                        
                                        {htmlParser.parse(currentEvent?.weddingOnviteMessage)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        currentEvent &&
                        currentEvent.eventMessages.length > 0 && (
                            <SingleMessagesView currentEvent={currentEvent} />
                        )
                    }
                    <div className="section-full-height"
                        style={{
                            backgroundImage:  `url(${backMemories})`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                        }}>
                        <div className="container">
                            {
                                memoryList &&
                                memoryList.length > 0 && 
                                memoryList.length <= 3 && (
                                    <SingleEventThreeLess eventItems={memoryList} />
                                )   
                            }
                        </div>
                    </div>
                </div>
            )
        }

        {
            onviteEvent && (
                <div className="content-layer">                    
                   <OnviteIntroduction onviteEvent={onviteEvent} rsvpList={rsvpList} />   
                   <SocialsShare 
                    eventId={params.id}
                    eventTitle={eventTitle}
                    />       
                </div>
            )
        }
        
        <MainFooter />
    </div>
  )
}

export default transition(SingleEvent)